import { gql } from 'graphql-request'

const GET_PUBLISHER = gql`
  query publisher($id: ID!) {
    publisher(id: $id) {
      accountManagerId
      createdAt
      enabled
      currency
      isEligibleForTurbo
      id
      name
      updatedAt
    }
  }
`

export default GET_PUBLISHER
